import React, { Component } from 'react';
import './Menu.css';
import Button from 'react-bootstrap/Button';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';
import Img from './banner.png';
import Img_small from './banner_smaller.png';
import Container from 'react-bootstrap/Container';
import { AiOutlineCloudUpload , AiOutlineHome } from "react-icons/ai";
import {Link} from 'react-router-dom';



const menu = (props) => {

    let CatValue = props.filterCategory;
    let VersionValue = props.filterVersion;
    let FilterValue = props.filterName;

    return (

    <div className="Menu">

        <Navbar bg="light" >
            <Container>
                
                <Button className="Button" variant="outline-secondary" href="https://pivotanimator.net">                
                    <AiOutlineHome style={{textDecoration: 'none'}}/>
                </Button>{' '}
                <div className="search-wrapper">
                        <label htmlFor="search-form">
                            <input
                                type="search"
                                name="search-form"
                                id="search-form"
                                className="search-input"
                                placeholder="Search"
                                value= {props.filterName}
                                onChange= {(e) => props.filter(e.target.value) }
                            />
                        </label>
                </div>
                
                <div   align="center">
                <a href="/stk-library/"><img  className="greetingImage" src={Img}></img></a>  
                <a href="/stk-library/"><img  className="greetingImageSmall" src={Img_small}></img></a> 
                    
                </div>
                
                    <Nav className="justify-content-end">
                    <Navbar.Text> Category:</Navbar.Text>
                    <NavDropdown title={CatValue} id="nav-dropdown"> 
                        <NavDropdown.Item onClick={(e) => props.clickcat(e.target.textContent)}>All</NavDropdown.Item>
                        <NavDropdown.Item onClick={(e) => props.clickcat(e.target.textContent)}>Aliens</NavDropdown.Item>
                        <NavDropdown.Item onClick={(e) => props.clickcat(e.target.textContent)}>Animals</NavDropdown.Item>
                        <NavDropdown.Item onClick={(e) => props.clickcat(e.target.textContent)}>Backgrounds</NavDropdown.Item>
                        <NavDropdown.Item onClick={(e) => props.clickcat(e.target.textContent)}>Effects</NavDropdown.Item>
                        <NavDropdown.Item onClick={(e) => props.clickcat(e.target.textContent)}>Objects</NavDropdown.Item>
                        <NavDropdown.Item onClick={(e) => props.clickcat(e.target.textContent)}>People</NavDropdown.Item>
                        <NavDropdown.Item onClick={(e) => props.clickcat(e.target.textContent)}>Robots</NavDropdown.Item>
                        <NavDropdown.Item onClick={(e) => props.clickcat(e.target.textContent)}>Text</NavDropdown.Item>
                        <NavDropdown.Item onClick={(e) => props.clickcat(e.target.textContent)}>Vehicles</NavDropdown.Item>
                        <NavDropdown.Item onClick={(e) => props.clickcat(e.target.textContent)}>Weapons</NavDropdown.Item>
                        
                    </NavDropdown>{' '}
                    <Navbar.Text> Version:</Navbar.Text>
                    <NavDropdown title={VersionValue} id="nav-dropdown"> 
                        <NavDropdown.Item onClick={(e) => props.clickVersion(e.target.textContent)}>All</NavDropdown.Item>
                        <NavDropdown.Item onClick={(e) => props.clickVersion(e.target.textContent)}>2</NavDropdown.Item>
                        <NavDropdown.Item onClick={(e) => props.clickVersion(e.target.textContent)}>3</NavDropdown.Item>
                        <NavDropdown.Item onClick={(e) => props.clickVersion(e.target.textContent)}>4 or less</NavDropdown.Item>
                        <NavDropdown.Item onClick={(e) => props.clickVersion(e.target.textContent)}>4</NavDropdown.Item>
                        <NavDropdown.Item onClick={(e) => props.clickVersion(e.target.textContent)}>5</NavDropdown.Item>
                        
                    </NavDropdown>
                    <Link to="../upload" style={{textDecoration: 'none'}}>
                        <Button  type="button" variant="outline-secondary" >
                            <AiOutlineCloudUpload  style={{textDecoration: 'none'}}/>
                        </Button>
                    </Link>
                </Nav>

            </Container>
            
        </Navbar>
        

    </div>
      
    )};
export default menu;
